import { MdlDialogReference } from '@angular-mdl/core';
import { ChangeDetectionStrategy, Component, Inject, InjectionToken, ChangeDetectorRef } from '@angular/core';
import { GridHeader, GridDetails } from '../../../../sample-tracking/tracking-overview/interfaces/grid';
import { DataRevisionData, DataRevisionStorage } from '../../data-revision-storage';
export const DATA_REVISION_DIALOG_TOKEN = new InjectionToken('DataRevisionDialog');
import { DataRevisionRequestData } from '../../data-revision-info';


@Component({
    selector: 'data-revision',
    template: require('./data-revision.component.html'),
    styles: [require('./data-revision.component.scss')],
    changeDetection: ChangeDetectionStrategy.OnPush
})

export class DataRevisionComponent {

    public data: ModalData;
    public columnDefs$: GridHeader[];
    public gridDetails: GridDetails;
    public defaultOrderByField = 'column';
    public gridLoadingComplete: boolean;

    constructor(
        private dialog: MdlDialogReference,
        private readonly changeDetector: ChangeDetectorRef, private dataRevisionStorage: DataRevisionStorage,
        @Inject(DATA_REVISION_DIALOG_TOKEN) private readonly dialogData: ModalData
    ) {
        this.data = dialogData;

        this.loadData();
       
    }
    public loadData() {
        this.gridLoadingComplete = false;

        let datarevisionrequest: DataRevisionRequestData = { type: this.data.type, labtestid: this.data.labTestId };
        this.dataRevisionStorage.loadDataRevision(datarevisionrequest).subscribe((result) => {
            this.data.data = result;
            this.gridLoadingComplete = true;

            let dataRevisionData = this.data.data[0] as DataRevisionData;
            this.data.protocol = dataRevisionData.protocol;
            this.data.investigatorNumber = dataRevisionData.investigatornumber;
            this.gridDetails = { data: this.data.data, header: this.getHeader() };
            this.changeDetector.markForCheck();  
        });

    }

    public close() {
        this.dialog.hide();
    }


    public getHeader(): GridHeader[] {
        let headerList = [
            {
                key: 'column',
                displayText: 'Property',
                enableFilter: true,
                defaultValue: ' ',
                enableSearch: true,
            },
            {
                key: 'revisedFrom',
                displayText: 'Revised From',
                enableFilter: true,
                defaultValue: ' ',
                enableSearch: true,
            },
            {
                key: 'revisedTo',
                displayText: 'Revised To',
                enableFilter: true,
                enableSearch: true,
                defaultValue: ' ',
            },
            {
                key: 'changedDate',
                displayText: 'Changed On',
                enableFilter: true,
                enableSearch: true,
                defaultValue: ' ',
                isDate: true
            }
        ];
        return headerList.map(t => t);
    }
   
}

export interface ModalData {
    labTestId: number;
    type: string;
    title: string;
    data: any;
    protocol: string;
    participantNumber: string;
    investigatorNumber: string;
    accessionNumber: string;
    visitDescription: string;
    closeButtonText: string;
    reverseButtons?: boolean;
    displayClose?: boolean;
}
